function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Splide from '@splidejs/splide';
document.addEventListener('DOMContentLoaded', function () {
  // Product list carousel
  var productListSplide = new Splide('.product-list', {
    type: 'loop',
    padding: {
      left: 0,
      right: '12rem'
    },
    perPage: 4,
    pagination: false,
    breakpoints: {
      1200: {
        perPage: 3,
        padding: {
          left: 0,
          right: '10rem'
        }
      },
      540: {
        perPage: 2,
        padding: 10
      }
    }
  });
  productListSplide.mount();

  // Showcase carousel
  var showCaseSplide = new Splide('.showcase', _defineProperty(_defineProperty(_defineProperty({
    type: 'loop',
    focus: 'center'
  }, "focus", 'center'), "autoWidth", true), "pagination", false));
  showCaseSplide.mount();

  // Columns Splide
  var columnsSplide = document.querySelectorAll('.columns__content.splide');
  columnsSplide.forEach(function (columnsElement) {
    var columnGap = parseInt(columnsElement.dataset.gap);
    var carouselPadding = columnsElement.classList.contains('columns__content--divider') ? '2rem' : {
      left: '24px',
      right: '12rem'
    };
    var columnsSplide = new Splide(columnsElement, {
      type: 'loop',
      padding: carouselPadding,
      focus: 'center',
      perPage: 1,
      pagination: false,
      autoHeight: true,
      mediaQuery: 'min',
      gap: columnGap,
      autoWidth: true,
      breakpoints: {
        1024: {
          destroy: true
        }
      }
    });
    columnsSplide.mount();
  });
});